<template>
  <div class="opc-layout" id="the-main-content">
    <!-- 
      When `showIAPRedirectLoading` is true, we show a loading screen as the initial view 
      instead of the regular skeleton UI. 
      This is based on design requirements and only applies to the "in-app purchase" scenario 
      when the user is redirected from the native app client.
    -->
    <div v-if="showIAPRedirectLoading" class="opc-layout__redirect_loading_layer">
      <p>{{ $t('billing.redirected_to') }}<br/>{{ locationDomain }}</p>
      <img :src="LoadingSpikes" />
    </div>
    <template v-else>
      <div class="opc-layout__main" role="main">
        <div class="opc-layout__main__inner">
          <template v-if="globalErrorState"><error-config /></template>
          <template v-else><slot></slot></template>
        </div>
      </div>
      <div class="opc-layout__side" role="complementary">
        <template v-if="globalErrorState"><error-cart /></template>
        <template v-else><slot name="side"></slot></template>
      </div>
    </template>
  </div>
</template>

<script>
import ErrorConfig from '@/components/error/config';
import ErrorCart from '@/components/error/cart';
import { mapGetters } from 'vuex';
import { iapLoadingLayerMixin } from '@/utils/iap.js';

export default {
  name: 'viewLayoutDesktop',
  mixins: [iapLoadingLayerMixin()],
  components: { ErrorCart, ErrorConfig },
  props: {
    title: String,
  },
  computed: {
    ...mapGetters(["globalErrorState"])
  },
};
</script>

<style lang="scss" scoped>
@import '@/styles/iap.scss';

$main-width: 60%;
$side-width: 40%;
$main-inner-width: 650px;

.opc-layout {
  margin: 0 auto;
  display: flex;
  flex-direction: row;

  &__main {
    flex: 1;

    &__inner {
      display: flex;
      flex-direction: column;
      align-items: center;
      width: 100% - $side-width;
      min-width: $main-inner-width;
      @media screen and (max-width: 1024px) {
        min-width: 0px;
      }
      @media screen and (min-width: 1025px) and (max-width: 1366px) {
        min-width: 580px;
      }
      @media screen and (min-width: 1367px) {
        min-width: 650px;
      }
      padding: 40px 0 64px;
      margin: 0 auto;
    }
  }

  &__side {
    position: relative;
    width: $side-width;
    background: #f7f7f8;
    ::v-deep .zm-skeleton {
      padding: 64px 60px 0;
    }
  }
}
</style>
